'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.areFromSameSender = undefined;

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

var areFromSameSender = exports.areFromSameSender = function areFromSameSender(messageA, messageB) {
  return (0, _commonMessageFormatGetters.getSenderId)(messageA) === (0, _commonMessageFormatGetters.getSenderId)(messageB) && (0, _commonMessageFormatGetters.getSenderType)(messageA) === (0, _commonMessageFormatGetters.getSenderType)(messageB);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/areFromSameSender.js
// module id = 1086
// module chunks = 2 3